import NotAllowed from "@/containers/StatusPages/NotAllowed";
import { FeatureType } from "@/features";
import { Feature } from "@components/Feature";

const withRequiredFeature = (
  WrappedComponent: React.ComponentType<unknown>,
  { feature }: { feature: FeatureType }
) => {
  const WithRequiredFeature = () => {
    return (
      <Feature required={feature} fallback={<NotAllowed />}>
        <WrappedComponent />
      </Feature>
    );
  };
  return WithRequiredFeature;
};

export default withRequiredFeature;
